import {
  createStore,
  applyMiddleware
} from 'redux';
import loggerMiddleware from 'redux-logger'
import createSagaMiddleware from 'redux-saga';
import { routerMiddleware } from 'react-router-redux';
import reducers from '../reducers';
import sagas from '../sagas';

// historyは src/index.js から渡される
export default function configureStore(history) {
  const sagaMiddleware = createSagaMiddleware();

  const store = createStore(
    reducers,
    history,
    applyMiddleware(
      loggerMiddleware,
      sagaMiddleware,
      routerMiddleware(history),
    ),
  );

  sagaMiddleware.run(sagas);

  return store;
}


// WEBPACK FOOTER //
// ./src/store/index.js